import {
  type EdgeId,
  type EdgeRecord,
  type NodeId,
  dataForPositionsFromEdge,
  getEdgePositions,
} from '@ipfabric/utils';
import { areAllElementsNonNullable } from '@ipfabric/utils/fp/areAllElementsNonNullable';
import type { GraphData } from 'components/Graph/model/GraphData';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { produce } from 'immer';

export function updateMovedNodesEdges(
  graph: GraphData,
  movedNodeIds: NodeId[],
): EdgeRecord {
  const affectedEdgeIds = movedNodeIds.reduce((result, nodeId) => {
    // Fixed noUncheckedIndexedAccess NIM-19408
    for (const edgeId of graph.nodesEdgesMap[nodeId]!) {
      result.add(edgeId);
    }
    return result;
  }, new Set<EdgeId>());
  return produce(graph.edges, (draft) => {
    for (const edgeId of affectedEdgeIds) {
      const edge = draft[edgeId];
      if (!edge) {
        return;
      }
      edge.positions = pipe(
        [graph.nodes[edge.source], graph.nodes[edge.target]],
        option.fromPredicate(areAllElementsNonNullable),
        option.map(([source, target]) =>
          // Fixed noUncheckedIndexedAccess NIM-19408
          getEdgePositions(source!, target!, dataForPositionsFromEdge(edge)),
        ),
        option.toNullable,
      );
    }
  });
}
